module.exports = __webpack_public_path__ + "6907baf7a5084499ab5db60d3fb327e9.pdf";